<template>
    <div>
        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <b-form @submit.prevent="crear()">
            <b-form-group label="Tipo de usuario">
                <b-input-group class="mt-3">
                    <b-form-input id="document-type-input" v-model="name"></b-form-input>
                    <b-input-group-append>
                        <b-button
                            type="submit"
                            :disabled="habilitarBoton"
                            variant="outline-primary"
                            class="ms-3"
                            id="create-type-user-button"
                        >
                            Crear
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-form>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames } from '@/plugins/enums/index.js'

export default {
    name: 'TypeUserForm',

    data(){
        return{
            name: '',
            habilitarBoton: true,
        }
    },

    components: {
        AlertDismiss
    },

    methods:{
        ...mapActions(["saveRole"]),

        clear(){
            this.name = '';
            this.habilitarBoton = true;
        },

        async crear(){
            let result =  await this.saveRole({ name: this.name })

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }
            
            this.$eventBus.$emit(EventNames.CreatedUserType, result);
            
            this.clear();
            this.$refs.alertDismiss.showAlert('Tipo de usuario creado correctamente.', 'success');
        }
    },

    watch:{
        'name'(newValue){
            if(newValue != ''){
                this.habilitarBoton = false;
            }
            else{
                this.habilitarBoton = true;
            }
        }
    }
    
}
</script>
<style>
    
</style>